import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navBackground: '#20407f',  //导航栏主题颜色
        currentRouter: '', //当前路由 
        adminCurrentRouter: '',
    },
    mutations: {
        // 回到顶部
        /**
         * 平滑滚动页面到指定的垂直位置（默认顶部）。
         *
         * @param {Object} state - Vuex 的 state 对象（未使用，仅为兼容性保留）。
         * @param {number} [target=0] - 目标滚动到的垂直位置（单位：像素），默认为 0（页面顶部）。
         *
         * @description
         * 该方法通过递归调用 window.requestAnimationFrame ，实现平滑滚动到目标位置。
         * 每一帧都会将页面滚动位置减少一定的距离，直到到达目标位置。
         */
        GoTop(state, target = 0) {
            const scrollToTop = () => { // 定义一个名为 scrollToTop 的箭头函数
                const currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; // 获取当前页面的垂直滚动距离，兼容不同浏览器
                if (currentScroll > target) { // 如果当前滚动位置大于目标位置
                    window.scrollTo(0, currentScroll - Math.max(10, (currentScroll - target) / 7)); // 以递减的方式滚动页面，步长为10或剩余距离的1/7，取较大值
                    window.requestAnimationFrame(scrollToTop); // 使用 requestAnimationFrame 递归调用 scrollToTop，实现平滑滚动
                }
            };
            scrollToTop(); // 调用 scrollToTop 函数，开始滚动到顶部
        }
    },
    actions: {
    },
    modules: {

    }
})
